import { localizeSystemText } from '../../i18n/messages';
import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { lessonTypeLabel, lessonTimeLabel, polishDate } from './clientPortalSelectors';
import { useTranslation } from 'react-i18next';

export default function LessonCard({ lesson, lessonTypes, disabled, confirming, onRequest, onDismiss, onConfirm, onUndo }) {
  const { t: tr, i18n } = useTranslation();
  const actionRef = useRef(null);
  const cancelled = lesson.lessonStatus === 'cancelled';
  const participation = { cancelledOnTime: tr("client:participationCancelledOnTime_53"), cancelledLate: tr("client:participationCancelledAfterTheDeadline_54"), cancelled: tr("client:participationCancelled_5") }[lesson.participationStatus];
  const dismiss = () => { onDismiss(); if (actionRef.current) actionRef.current.focus(); };
  const closeConfirmation = event => { if (event.key === 'Escape' && !disabled) dismiss(); };
  return (
    <article className="client-portal__lesson-card">
      <div className="client-portal__lesson-date">{polishDate(lesson.date, true, i18n.language)}</div>
      <div className="client-portal__lesson-time">{lessonTimeLabel(lesson, lessonTypes, i18n.language)}</div>
      <div className="client-portal__lesson-type">{lessonTypeLabel(lesson.classTypeId, lessonTypes, i18n.language)}</div>
      <div>{lesson.studentName}</div>
      {cancelled && <p className="client-portal__status">{tr("manage:lessonCancelled_54")}</p>}
      {!cancelled && participation && <p className="client-portal__status">{participation}</p>}
      <div className="client-portal__lesson-actions">
        {lesson.canCancel && <button ref={actionRef} type="button" className="btn btn-outline-secondary" disabled={disabled} onClick={confirming ? dismiss : onRequest}>{tr("client:reportAnAbsence_55")}</button>}
        {lesson.canUndoCancellation && <button type="button" className="btn manage-teal-button" disabled={disabled} onClick={onUndo}>{tr("manage:undoCancellation_4")}</button>}
      </div>
      {confirming && lesson.canCancel && (
      <div className="client-portal__confirmation" role="group" aria-label={tr("client:confirmCancellation_56")}>
        <p>{lesson.cancellationEligibility && (typeof lesson.cancellationEligibility.chargeable === 'boolean'
          ? tr(lesson.cancellationEligibility.chargeable
            ? (lesson.cancellationEligibility.onTime ? 'client:cancellationOnTimePaid' : 'client:cancellationCharged')
            : 'client:cancellationFree')
          : localizeSystemText(lesson.cancellationEligibility.message, tr))}</p>
        <div className="client-portal__lesson-actions">
          <button type="button" className="btn manage-teal-button" disabled={disabled} onKeyDown={closeConfirmation} onClick={dismiss}>{tr("common:cancel")}</button>
          <button type="button" className="btn manage-red-button" disabled={disabled} onKeyDown={closeConfirmation} onClick={onConfirm}>{tr("client:confirmCancellation_57")}</button>
        </div>
      </div>
      )}
    </article>
  );
}
LessonCard.propTypes = {
  lesson: PropTypes.object.isRequired,
  lessonTypes: PropTypes.array.isRequired,
  disabled: PropTypes.bool.isRequired,
  confirming: PropTypes.bool.isRequired,
  onRequest: PropTypes.func.isRequired,
  onDismiss: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onUndo: PropTypes.func.isRequired,
};
